import { render, staticRenderFns } from "./TouristsInput.vue?vue&type=template&id=5f056fc3"
import script from "./TouristsInput.vue?vue&type=script&lang=js"
export * from "./TouristsInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports